import { GlobalImage } from "config/image";
import React from "react";
import { CompanyPayload } from "types/auth.api";
import { ClientsPayloadData } from "types/client.api";
import SmartImage from "../SmartImage";

interface SenderAndBillingDetailsProps {
  isFromTempLate2?: boolean;
  isBillingDetails: boolean;
  className?: string;
  colorName?: string;
  companyDetails?: CompanyPayload | null;
  clientDetails?: ClientsPayloadData | null;
  issueDate?: string;
  dueDate?: string;
  referenceNumber?: string;
  isBelowQuote?: boolean;
  quoteName?: string;
  isCompanyPhoneHidden?: boolean;
  isCompanyNameHidden?: boolean;
}

const SenderAndBillingDetails: React.FC<SenderAndBillingDetailsProps> = ({
  isFromTempLate2,
  isBillingDetails,
  className,
  colorName = "primary",
  clientDetails,
  companyDetails,
  dueDate,
  issueDate,
  referenceNumber,
  isBelowQuote,
  quoteName,
  isCompanyPhoneHidden,
  isCompanyNameHidden,
}) => {
  console.log("companyDetails", companyDetails);

  const billingAddress = [
    clientDetails?.address,
    clientDetails?.city,
    clientDetails?.postcode,
    clientDetails?.country,
  ]
    .filter(Boolean)
    .join(", ");

  const companyAddress = [
    companyDetails?.address?.address,
    companyDetails?.address?.city,
    companyDetails?.address?.postcode,
    companyDetails?.address?.country,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <div className={`mt-3 ${className}`}>
      {/* HEADER */}
      <div className="fw-medium text-black2d font-primary mb-2">
        {isBillingDetails ? (
          <span style={{ color: colorName }}>Client:</span>
        ) : (
          <div className="d-flex gap-2 align-items-center">
            {companyDetails?.logo?.length && (
              // <SmartImage src={companyDetails.logo} alt="logo" maxHeight={60} />
              <div
                style={{
                  borderWidth: "0.5px",
                  borderStyle: "solid",
                  borderColor: "#89909D",
                }}
              >
                <SmartImage
                  src={companyDetails.logo}
                  alt="logo"
                  maxHeight={60}
                />
              </div>
            )}

            <span className="text-black2D font-primary fw-medium">
              {!isCompanyNameHidden && companyDetails?.name}
            </span>
          </div>
        )}
      </div>

      {/* CLIENT NAME */}
      {isBillingDetails && (
        <div
          className="text-black2D font-primary fw-normal"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            marginRight: 20,
          }}
        >
          {clientDetails?.name}
        </div>
      )}

      {/* BODY */}
      <div className="d-flex align-items-start mt-1">
        {/* LEFT COLUMN (CRITICAL FIX) */}
        <div
          className="d-flex flex-column gap-1 flex-grow-1 pe-3"
          style={{ minWidth: 0 }}
        >
          <div className="text-black2D font-primary fw-normal">
            {isBillingDetails
              ? clientDetails?.phone
              : !isCompanyPhoneHidden &&
                `(+44) ${companyDetails?.billing_details?.phone}`}
          </div>
          {!isBillingDetails && companyDetails?.email && (
            <div className="text-black2D font-primary fw-normal">
              {`${companyDetails?.email}`}
            </div>
          )}

          <div
            className="text-black2D font-primary fw-normal"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 6,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              marginRight: 20,
              maxWidth: "90%",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {isBillingDetails ? billingAddress : companyAddress}
          </div>
        </div>

        {/* RIGHT COLUMN */}
        {!isFromTempLate2 && (
          <div className="d-flex flex-column flex-shrink-0">
            {isBelowQuote && (
              <div style={{ marginTop: -24 }}>
                <div className="d-flex gap-2">
                  <span className="fw-medium" style={{ color: colorName }}>
                    Quote Ref:
                  </span>
                  <span className="text-black2D font-primary fw-normal">
                    {referenceNumber}
                  </span>
                </div>

                {quoteName && (
                  <div
                    className="text-black2D font-primary fw-normal mt-1"
                    style={{
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                      maxWidth: 160,
                    }}
                  >
                    {quoteName}
                  </div>
                )}
              </div>
            )}

            <div className="d-flex gap-2 mb-1">
              {isBillingDetails && (
                <span className="fw-medium" style={{ color: colorName }}>
                  Issue Date:
                </span>
              )}
              <span
                className="fw-normal"
                style={!isBillingDetails ? { color: colorName } : {}}
              >
                {isBillingDetails ? issueDate : "Quote Ref:"}
              </span>
            </div>

            <div className="d-flex gap-2">
              {isBillingDetails && (
                <span className="fw-medium" style={{ color: colorName }}>
                  Due Date:
                </span>
              )}
              <span
                className={`text-black2D font-primary ${
                  isBillingDetails ? "fw-normal" : "fw-medium"
                }`}
              >
                {isBillingDetails ? dueDate : referenceNumber}
              </span>
            </div>
            {!isBillingDetails && quoteName && (
              <div style={{ maxWidth: 160 }}>
                <span
                  className="text-black2D font-primary fw-medium"
                  style={{
                    display: "block",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {quoteName}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(SenderAndBillingDetails);
